import { render, staticRenderFns } from "./ChildProducts.vue?vue&type=template&id=37e511db&"
import script from "./ChildProducts.vue?vue&type=script&lang=js&"
export * from "./ChildProducts.vue?vue&type=script&lang=js&"
import style0 from "./ChildProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports